import React from 'react';
import { WebSiteHeightProvider } from './src/context';

export const wrapRootElement = ({ element }) => (
  <WebSiteHeightProvider>{element}</WebSiteHeightProvider>
);

export function shouldUpdateScroll() {
  window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
  return false;
}
